import { $Enums } from '@prisma/client';
import { ContentType } from './content';

/**
 * Target polymorphic model interface based on Prisma schema
 * Represents a polymorphic relation between content types
 */
export interface ITarget {
  id: string;
  type: $Enums.ContentType;
  productId?: string | null;
  articleId?: string | null;
  projectId?: string | null;
  locationId?: string | null;
  serviceId?: string | null;
}

/**
 * Target with interactionStats property
 */
export interface TargetWithStats extends ITarget {
  interactionStat?: {
    id: string;
    stats: {
      viewCount: number;
      favouriteCount: number;
      ratingCount: number;
      averageRating: number;
      commentCount: number;
      reviewCount: number;
      shares?: {
        facebook: number;
        x: number;
        reddit: number;
        instagram: number;
        linkedin: number;
      };
    };
  };
}

/**
 * Maps a content type to its corresponding ID field in the Target model
 */
export const ContentTypeToTargetField: Record<ContentType, keyof ITarget> = {
  PRODUCT: 'productId',
  ARTICLE: 'articleId',
  PROJECT: 'projectId',
  SERVICE: 'serviceId',
  LOCATION: 'locationId',
  NONE: 'id',
};

/**
 * Helper function to get the content ID from a Target object
 */
export function getContentIdFromTarget(target: ITarget): string | undefined {
  const fieldName = ContentTypeToTargetField[target.type];
  return target[fieldName] as string | undefined;
}
